import * as yup from "yup";

export const schemaIndex = yup.object().shape({
  title: yup.string().nullable(true),
});

export const schemaShow = yup.object().shape({
  name: yup
    .string()
    .min(3, "Minimum 3 characters")
    .max(255, "Maximum 255 characters")
    .required("Name is required"),
  timezone: yup.string().required("Timezone is required"),
  message: yup
    .string()
    .required("Message is required")
    .min(3, "Minimum 3 characters")
    .max(255, "Maximum 255 characters"),
  skills_id: yup
    .array()
    .required("At least one skill is required"),
  config: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string(),
        dateRange: yup.array().of(yup.string()),
      })
    )
    .nullable(true)
    .required("Occurrences is required"),

  configName: yup
    .string()
    .min(3, "Minimum 3 characters")
    .max(255, "Maximum 255 characters")
    .nullable(true),
  configStart: yup.string().nullable(true),
  configEnd: yup.string().nullable(true),
});
